import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState('')
  const [newPass, setNewPass] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState('')
  const [success, setSuccess] = useState(false)

  const handleChange = async (e) => {
    e.preventDefault()
    setError('')
    if (newPass !== confirm)  { setError('New passwords do not match.'); return }
    if (newPass.length < 8)   { setError('Password must be at least 8 characters.'); return }
    if (newPass === current)  { setError('New password must be different from current.'); return }
    setLoading(true)

    const { data: { user } } = await supabase.auth.getUser()
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: user.email, password: current
    })
    if (signInError) { setError('Current password is incorrect.'); setLoading(false); return }

    const { error: updateError } = await supabase.auth.updateUser({ password: newPass })
    if (updateError) { setError(updateError.message); setLoading(false); return }

    setSuccess(true)
    setTimeout(() => { onClose() }, 2000)
    setLoading(false)
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
    }}>
      <div style={{
        background: '#fff', borderRadius: 14, padding: 32, width: '100%',
        maxWidth: 420, boxShadow: '0 8px 40px rgba(0,0,0,0.18)'
      }}>
        <h3 style={{ margin: '0 0 20px', fontSize: '1.1rem' }}>Change password</h3>

        {error   && <div className="alert alert-error"   style={{ marginBottom: 14 }}>⚠ {error}</div>}
        {success && <div className="alert alert-success" style={{ marginBottom: 14 }}>✓ Password updated! Closing…</div>}

        {!success && (
          <form onSubmit={handleChange}>
            <div className="form-group">
              <label>Current password</label>
              <input type="password" value={current}
                onChange={e => setCurrent(e.target.value)}
                placeholder="Your current password"
                autoComplete="current-password" />
            </div>
            <div className="form-group">
              <label>New password</label>
              <input type="password" value={newPass}
                onChange={e => setNewPass(e.target.value)}
                placeholder="At least 8 characters"
                autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label>Confirm new password</label>
              <input type="password" value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Repeat new password"
                autoComplete="new-password" />
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
              <button className="btn btn-primary" type="submit"
                disabled={loading || !current || !newPass || !confirm}
                style={{ width: 'auto', padding: '9px 20px' }}>
                {loading ? 'Updating…' : 'Update password'}
              </button>
              <button type="button" className="btn btn-ghost"
                onClick={onClose}
                style={{ padding: '9px 20px' }}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
